import _ from 'lodash'
import moment from 'moment/moment'

export default personalInformationDetail

/** @ngInject */
function personalInformationDetail($uibModal, $timeout, $state, ApiService, User, ContactTelephone, ErrorCatcher) {
    return ({
        restrict: 'E',
        scope: {
            userInfo: '<',
        },
        template: require('./personalInformationDetail.jade')(),
        link($scope) {
            $scope.contactTelephone = ContactTelephone
            $scope.billingAddress = {
                value: null,
                isLoading: false,
            }
            $scope.myIban = {
                value: null,
                isLoading: false,
            }
            $scope.isEditing = false
            $scope.isSubmitting = false
            $scope.addSecondNominal = false
            $scope.error = null
            $scope.nominalForm = {
                identity: {},
            }
            $scope.form = {
                givenname: null,
                sn: null,
                civ: null,
                birth_date: null,
                givenname2: null,
                sn2: null,
                civ2: null,
                accept_contacts: null,
            }

            $scope.editForm = function () {
                $scope.isEditing = true
                $scope.isSubmitting = false
                $scope.addSecondNominal = !_.isEmpty($scope.userInfo.civ2)
                $scope.form = {
                    givenname: $scope.userInfo.givenname,
                    sn: $scope.userInfo.sn,
                    civ: $scope.userInfo.civ,
                    birth_date: $scope.userInfo.birth_date,
                    givenname2: $scope.userInfo.givenname2,
                    sn2: $scope.userInfo.sn2,
                    civ2: $scope.userInfo.civ2,
                    accept_contacts: $scope.userInfo.accept_contacts,
                }
            }

            $scope.closeForm = function () {
                $scope.isEditing = false
                $scope.isSubmitting = false
            }

            $scope.toggleAddSecondNominal = function () {
                $scope.addSecondNominal = !$scope.addSecondNominal
                if ($scope.addSecondNominal === false) {
                    $scope.form.givenname2 = null
                    $scope.form.sn2 = null
                    $scope.form.civ2 = null
                }
            }

            $scope.reloadData = () => {
                // Reload userInfo instead of reloading page (currently break transition & page animation)
                ApiService.resetPromise('userInfo')
                $state.go($state.current, { contractId: $scope.userInfo.contractSelected.id }, { reload: true })
            }

            $scope.submit = function () {
                $scope.nominalForm.identity.$setSubmitted()
                if ($scope.nominalForm.identity.$invalid || !moment($scope.form.birth_date).isValid()) {
                    return
                }

                $scope.isSubmitting = true
                User.saveNominativeInfo(_.assign({}, $scope.form, { birth_date: moment($scope.form.birth_date).format('YYYY-MM-DD') })).$promise.then(() => {
                    $scope.closeForm()
                    $scope.reloadData()
                }).catch((error) => {
                    ErrorCatcher.catchError(error)
                    $scope.isSubmitting = false
                    $scope.error = error
                })
            }

            $scope.openChangePasswordModal = () => {
                $uibModal.open({
                    animation: true,
                    component: 'changePasswordModal',
                    resolve: {
                        email: () => $scope.userInfo.mail,
                    },
                }).result.then((result) => {
                    if (result.isSubmitted) {
                        $scope.reloadData()
                    }
                })
            }

            $scope.openChangeEmailModal = () => {
                $uibModal.open({
                    animation: true,
                    component: 'changeEmailModal',
                }).result.then((result) => {
                    if (result.isSubmitted) {
                        $scope.reloadData()
                    }
                })
            }

            $scope.openChangeMobileModal = (currentPhoneNumber) => {
                $uibModal.open({
                    animation: true,
                    component: 'changeMobileModal',
                    resolve: {
                        currentPhoneNumber: () => currentPhoneNumber,
                    },
                }).result.then((result) => {
                    if (result.isSubmitted) {
                        $scope.reloadData()
                    }
                })
            }

            $scope.openChangeBillingAddress = () => {
                $uibModal.open({
                    animation: true,
                    component: 'changeBillingAddressModal',
                    size: 'lg',
                }).result.then((result) => {
                    if (result.isSubmitted) {
                        $scope.reloadData()
                    }
                })
            }

            $scope.openChangeSelectedPaymentMethodModal = (recurrentCbPayment) => {
                $uibModal.open({
                    animation: true,
                    component: 'changeSelectedPaymentMethodModal',
                    resolve: {
                        recurrentCbPayment: () => recurrentCbPayment,
                    },
                    size: 'lg',
                }).result.then((result) => {
                    if (result.isSubmitted) {
                        $scope.reloadData()
                    }
                })
            }

            $scope.openDeleteCreditCardModal = () => {
                $uibModal.open({
                    animation: true,
                    component: 'deleteCreditCardModal',
                    size: 'lg',
                }).result.then((result) => {
                    if (result.isSubmitted) {
                        $scope.reloadData()
                    }
                })
            }

            $scope.openDeleteMandateModal = () => {
                $uibModal.open({
                    animation: true,
                    component: 'deleteMandateModal',
                    size: 'lg',
                }).result.then((result) => {
                    if (result.isSubmitted) {
                        $scope.reloadData()
                    }
                })
            }

            $scope.signMandate = () => {
                return User.signMandate().$promise.then((result) => {
                    window.open(result.redirectUrl, '_newtab')
                }).catch((error) => {
                    ErrorCatcher.catchError(error)
                    this.errorMessage = error.data.message
                })
            }

            $scope.addCreditCard = () => {
                return User.createAlias().$promise.then((result) => {
                    window.open(result.redirectUrl, '_newtab')
                }).catch((error) => {
                    ErrorCatcher.catchError(error)
                    this.errorMessage = error.data.message
                })
            }

            $scope.getBillingAddress = () => {
                $scope.billingAddress.isLoading = true
                return User.getBillingAddress().$promise.then((billingAddressResult) => {
                    $scope.billingAddress.value = billingAddressResult
                })
                .catch(ErrorCatcher.catchError)
                .finally(() => {
                    $scope.billingAddress.isLoading = false
                })
            }

            $scope.hasCreditCardExpired = () => {
                return moment().isAfter(moment($scope.billingAddress.value.alias_expiration))
            }

            $scope.getIban = () => {
                User.getMyIban().$promise.then((myIbanResult) => {
                    $scope.myIban.value = myIbanResult
                }).catch((error) => {
                    ErrorCatcher.catchError(error)
                    this.errorMessage = error.data.message
                })
            }

            const activate = () => {
                $scope.getBillingAddress()
                $scope.getIban()
            }
            activate()
        },
    })
}



// WEBPACK FOOTER //
// ./src/states/personalInformation/component/personalInformationDetail.js